import { useState, useEffect} from 'react';
import { Paper, Stack, Button, Grid, Typography, MenuItem, Box, FormControl, InputLabel, Select, Checkbox, ListItemText, OutlinedInput } from '@mui/material'
import DBQuoteOfTheDay from './DashboardComponents/DBQuoteOfTheDay'
import DBPortfolioHighLevel from './DashboardComponents/DBPortfolioHighLevel'
import DBPortfolioDetailed from './DashboardComponents/DBPortfolioDetailed'
import DBSectorPerformance from './DashboardComponents/DBSectorPerformance';
import DBGainersAndLosers from './DashboardComponents/DBGainersAndLosers';
import TickerSearch from './TickerSearch.js'

import { marketNamesWithPINX as marketNames, regionNames, sectorNames, marketCapValues } from "./Constants/constants";
import { useNavigate } from 'react-router-dom';


function Dashboard() {
  const [market, setMarket] = useState("CAN");
  const [regions, setRegions] = useState([]);
  const [sector, setSector] = useState("CD");
  const [marketCapMin, setMarketCapMin] = useState(0);
  const [marketCapMax, setMarketCapMax] = useState(10000000);
  const [regionDisplay, setRegionDisplay] = useState("");
  const [refreshEnabled, setRefreshEnabled] = useState(false);
  const navigate = useNavigate()
 
  const getSearchResults = () => {
    const payload = {
      market: market,
      regions: regions,
      sector: sector,
      marketCapMin: marketCapMin,
      marketCapMax: marketCapMax,
    };

    // console.log(payload)

   // handleGetSearchResults(payload);
  };

  const handleMarketChange = (event) => {
    const newMarket = event.target.value;
    //console.log(newMarket);
    setMarket(newMarket);

    if (newMarket === "PNX") {
      setRegionDisplay("block");
    } else {
      setRegionDisplay("none");
    }
    setRegions([]);
    localStorage.setItem("QS_Regions", []);

    localStorage.setItem("QS_Market", newMarket);

    setRefreshEnabled(true);
  };

  const handleRegionChange = (event) => {
    const newRegions = event.target.value;
    //console.log(newRegions);

    setRegions(newRegions);
    localStorage.setItem("QS_Regions", newRegions);

    setRefreshEnabled(true);
  };

  const handleMarketCapMinChange = (event) => {
    const newMarketCapMin = event.target.value;
    //console.log(newMarketCapMin);

    setMarketCapMin(newMarketCapMin);
    localStorage.setItem("QS_MarketCapMin", newMarketCapMin);

    setRefreshEnabled(true);
  };

  const handleMarketCapMaxChange = (event) => {
    const newMarketCapMax = event.target.value;
    //console.log(newMarketCapMax);

    setMarketCapMax(newMarketCapMax);
    localStorage.setItem("QS_MarketCapMax", newMarketCapMax);

    setRefreshEnabled(true);
  };

  const getMCapMinValues = () => {
    const mCapMinValues = marketCapValues.filter((mCap) => mCap.mCapMin === true && mCap.value < marketCapMax);
    return mCapMinValues;
  };

  const getMCapMaxValues = () => {
    const mCapMaxValues = marketCapValues.filter((mCap) => mCap.mCapMax === true && mCap.value > marketCapMin);
    return mCapMaxValues;
  };

  const handleTicker = (newTicker) => {
    if (!newTicker) return;
    console.log(newTicker)
    navigate(`/${newTicker.toLowerCase()}`); 
  };

  return (
    <Grid container sx={{ p: 4 }}>
      <Grid item xs={12}>        
        <Paper sx={{ p: 2 }}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={2}>
              <Box
                sx={{
                  width: "100%",
                  "& .MuiAutocomplete-root": { width: "100% !important" },
                  "& .MuiInputBase-root": {
                    width: "100% !important",
                    fontSize: "0.75rem",
                  },
                  "& .MuiInputLabel-root": { fontSize: "0.75rem" },
                  "& .MuiAutocomplete-option": { fontSize: "0.75rem" },
                  "& .MuiAutocomplete-popupIndicator": { display: "none" },
                }}
              >
                <TickerSearch
                  handleAddTicker={handleTicker}
                  fromCompanyDetail={true}
                />
              </Box>
            </Grid>

            <Grid item xs={12} md={10}>
              <DBQuoteOfTheDay />
            </Grid>
          </Grid>
        </Paper>
      </Grid>
      {/* <Grid>
      <Paper sx={{ mx: 1, mt: 1, p: 2 }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Box display={"flex"} alignItems={"center"}>
          <Box sx={{ ml: 2 }}>
            <FormControl sx={{ m: 0, width: 110 }} size="small">
              <InputLabel>Market</InputLabel>
              <Select value={market} onChange={handleMarketChange} input={<OutlinedInput label="Market" />}>
                {marketNames.map((market) => (
                  <MenuItem key={market.value} value={market.value}>
                    {market.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>

          <Box sx={{ ml: 2, display: regionDisplay }}>
            <FormControl sx={{ m: 0, minWidth: 200 }} size="small">
              <InputLabel>Regions</InputLabel>
              <Select multiple value={regions} onChange={handleRegionChange} input={<OutlinedInput label="Regions" />} renderValue={(selected) => selected.join(", ")}>
                {regionNames.map((region) => (
                  <MenuItem key={region.value} value={region.value}>
                    <Checkbox checked={regions.indexOf(region.value) > -1} />
                    <ListItemText primary={region.label + " - " + region.value} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>

          <Box sx={{ ml: 2 }}>
            <FormControl sx={{ m: 0, width: 150 }} size="small">
              <InputLabel>Market Cap Min</InputLabel>
              <Select value={marketCapMin} onChange={handleMarketCapMinChange} input={<OutlinedInput label="MarketCap Min" />}>
                {getMCapMinValues().map((marketCap) => (
                  <MenuItem key={marketCap.value} value={marketCap.value}>
                    {marketCap.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>

          <Box sx={{ ml: 2 }}>
            <FormControl sx={{ m: 0, width: 150 }} size="small">
              <InputLabel>Market Cap Max</InputLabel>
              <Select value={marketCapMax} onChange={handleMarketCapMaxChange} input={<OutlinedInput label="MarketCap Max" />}>
                {getMCapMaxValues().map((marketCap) => (
                  <MenuItem key={marketCap.value} value={marketCap.value}>
                    {marketCap.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>

          <Box sx={{ ml: 4 }}>
            <Button variant="contained" size="small" onClick={getSearchResults} disabled={!refreshEnabled}>
              Refresh
            </Button>
          </Box>
        </Box>
        </Stack>
        </Paper>
      </Grid>
      <Grid container columns={5} spacing={5}>
        {sectorNames.map((sector) => (
          <Grid item xs={1} key={sector.value}>
            <Typography key={sector.value} value={sector.value} varient='h6' sx={{ fontWeight: 'bold', marginBottom: 1, color: "#4e95d9", }}>
              {sector.label.split(" - ")[0]}
            </Typography>
          </Grid>
        ))}
      </Grid> */}


      {/* <Grid item xs={12} md={6}>
        <DBPortfolioHighLevel />
      </Grid>
      <Grid item xs={12} md={6}>
        <DBPortfolioDetailed />
      </Grid>
      <Grid item xs={12} md={6}>
        <DBSectorPerformance />
      </Grid>
      <Grid item xs={12} md={6}>
        <DBGainersAndLosers />
      </Grid> */}
    </Grid>);
}

export default Dashboard;
